const variables = {
  collaboration: {
    idleTimeout: 5 * 60 * 1000, // 5 minutes
    editionRoles: ['author', 'contributor'],
  },
  online: {
    detector: {
      testUrl: '/malcolm',
      refreshInterval: 10000,
      requestTimeout: 3000,
    },
    maxDowntime: 14500,
  },
  colors: {
    transparent: 'transparent',
    translucentWhite: 'rgba(255,255,255,0.05)',
    whiteHover: 'rgba(255,255,255,0.75)',
    white: '#FFFFFF',
    lightestGrey: '#FAFAFA',
    lighterGrey: '#EEEEEE',
    lightGrey: '#DDDDDD',
    lightMiddleGrey: '#CACACA',
    grey: '#D9D9D9',
    middleGrey: '#444246',
    darkGrey: '#212022',
    darkerGrey: '#1d1c1f',
    darkererGrey: '#0A0A0A',
    darkestGrey: '#18171A',
    translucentGrey: 'rgb(75, 75, 75)',
    transparentGrey: 'rgba(150, 150, 150,0.2)',
    translucentDarkestGrey: 'rgba(24, 23, 26, 0.9)',
    textGrey: '#9B9B9B',
    darkerTextGrey: '#777777',
    dashboardLighterGrey: '#F7F7F7',
    dashboardLightGrey: '#F2F2F2',
    dashboardGrey: '#A3A3A3',
    translucentLightBlack: 'rgba(0, 0, 0, 0.09)',
    black: '#000000',
    blue: '#4E56FF',
    translucentBlue: 'rgba(78, 86, 255, 0.9)',
    highlightBlue: '#666DFF',
    mediumBlue: '#4047a9',
    darkBlue: '#272B80',
    darkerBlue: '#141640',
    lightBlue: '#EFF0FF',
    turquoise: '#54E9DC',
    lightOrange: '#ff8482',
    orange: '#FF6562',
    darkOrange: '#804404',
    red: '#C40233',
    warningRed: 'red',
    darkRed: '#830122',
    facebook: '#3b5998',
    google: '#de5246',
    twitter: '#1da1f2',
    linkedin: '#0077b5',
    adobe: '#ff0000',
    green: '#4caf50',
    lightGreen: '#D0F0C0',
    lightRed: '#FFCCCB',
    transparentRed: '#ff003c1c',
    purple: '#D990FF',
    magenta: '#FF00BC',
  },
  defaultProperties: {
    fill: 'rgba(172,172,172,1)',
    translucentTint: 'rgba(78,86,255,0.5)',
    opaqueTint: 'rgba(78,86,255,1)',
  },
  placeholders: {
    title: 'Type your title here...',
    paragraph:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elit mauris, tristique vitae ligula sit amet, congue congue dui. Integer aliquam tincidunt dolor ut rutrum. Vestibulum luctus congue tempus. Aliquam vitae dolor eu risus ullamcorper consequat. Proin sit amet lobortis nisi.',
    bulletedList: 'First\nSecond\nThird',
  },
  shadows: {
    browserBlur: {
      edge: 1.75,
      chrome: 1.5,
      safari: 0.95,
      firefox: 0.9,
    },
    default: {
      color: 'rgba(0,0,0,0.6)',
      blur: 20,
      offsetX: 10,
      offsetY: 10,
    },
  },
  documentSizes: {
    default: {
      width: 1920,
      height: 1080,
    },
    min: {
      width: 100,
      height: 100,
    },
    max: {
      width: 2560,
      height: 2560,
    },
  },
  filters: [
    'tint',
    'contrast',
    'brightness',
    'saturation',
    'hue',
    'blur',
    'invert',
  ],
  // related to WebGL (5000 seems good value on discreet GPU)
  // in fabric & sizedown image too big
  maxImgSize: 1024 * 4,
  regularImgSize: 1024 * 4,
  zoom: {
    min: 0.125,
    max: 100.0,
    step: 0.25,
    default: 0.5,
    pixelGridZoom: 8.0,
  },
  canvasPadding: 100,
  numberPrecision: 8,
  errors: {
    default:
      'An error occurred. Please try again later. If the problem persists, contact <a href="mailto:support@ludus.one">support@ludus.one</a>.',
    editorCrash: {
      title: 'Something went wrong',
      message:
        'Don’t worry, your most recent changes should be safe. Try refreshing the page. If the problem persists, contact <a href="mailto:support@ludus.one">support@ludus.one</a>.',
    },
    crash: {
      title: 'Something went wrong',
      message:
        'Try refreshing the page. If the problem persists, contact <a href="mailto:support@ludus.one">support@ludus.one</a>.',
    },
    symbolInSymbol: {
      title: 'Sorry',
      message: 'Pasting a smart block into another smart block is not allowed',
    },
    slideCrash: {
      message: 'This slide could not be loaded.',
    },
    initialization:
      'Your presentation could not be loaded. Press OK to try again.',
    timeout:
      'It looks like you were disconnected. Click OK to try refreshing the page. If the problem persists, contact <a href="mailto:support@ludus.one">support@ludus.one</a>.',
    collaboration: {
      undoRedoDisabled:
        'Undo/Redo is disabled while working with other collaborators',
    },
    themes: {
      themeConflict:
        'Please provide another name to avoid confusion with other themes',
      templateConflict:
        'Please provide another name to avoid confusion with other templates',
    },
    drive: {
      noGoogleUser: {
        title: 'Authentication required',
        message:
          'We were not able to get your Google account information, please select the Google account you want to use.',
        action: 'Select account',
      },
      userIdDoesNotMatch: {
        title: 'Account mismatch (identifier)',
        message:
          "The Google Drive user identifier doesn't match the current Ludus user identifier.",
        action: 'Sign out',
      },
      userEmailDoesNotMatch: {
        title: 'Account mismatch (email)',
        message:
          "The Google Drive user email doesn't match the current Ludus user email.",
        action: 'Sign out',
      },
    },
  },

  propsToSave: [
    'background',
    'parentSymbol',
    'spaceAfterParagraph',
    'contents',
    'canvasId',
    'editable',
    'evented',
    'actualTransformMatrix',
    'leftIndent',
    'selectable',
    'strokeStyle',
    'strokeWidth',
    'lockUniScaling',
    'ludus',
    'perPixelTargetFind',
    'startAngle',
    'styleCase',
    'top',
    'left',
    'hash',
  ],
  lockProperties: {
    evented: false,
    selectable: false,
    lockMovementX: true,
    lockMovementY: true,
    hoverCursor: 'crosshair',
    borderColor: '#00C6C6',
    cornerColor: '#00C6C6',
    cornerStrokeColor: '#00C6C6',
    transparentCorners: false,
    cornerSize: 4,
    hasRotatingPoint: false,
  },
  regularProperties: {
    lockMovementX: false,
    lockMovementY: false,
    selectable: true,
    evented: true,
    hoverCursor: 'move',
    editable: true,
    hasRotatingPoint: true,
    transparentCorners: false,
    cornerSize: 9,
    borderColor: '#4DEADA',
    cornerColor: 'white',
    cornerStrokeColor: '#4DEADA',
    cornerStyle: 'rect',
    borderOpacityWhenMoving: 1,
    lockSkewingX: true,
    lockSkewingY: true,
    lockScalingFlip: true,
  },

  strokeStyles: [
    {
      name: 'solid',
      label:
        '<svg class="themableSVG" height="8" width="100%"><line x1="2" y1="5" x2="98%" y2="50%" stroke="white" stroke-width="4" stroke-linecap="round" /></svg>',
      values: '0,0',
    },
    {
      name: 'dots',
      label:
        '<svg class="themableSVG"height="8" width="100%"><line x1="2" y1="5" x2="98%" y2="50%" stroke="white" stroke-dasharray="0,8" stroke-width="4" stroke-linecap="round" /></svg>',
      values: '0,2*s',
    },
    {
      name: 'lined',
      label:
        '<svg class="themableSVG" height="8" width="100%"><line x1="2" y1="5" x2="98%" y2="50%" stroke="white" stroke-dasharray="12,12" stroke-width="4" stroke-linecap="round" /></svg>',
      values: 's*2,s*2',
    },
  ],
  transitions: {
    defaultTransitionName: 'None',
    minDuration: 50,
    maxDuration: 2000,
  },
  urls: {
    home: 'https://ludus.one',
    blog: 'https://blog.ludus.one',
    publishHelpArticle:
      'https://help.ludus.one/Features/Editor/Basics/publish-presentation',
  },
  windows: {
    embed: 'ludus_embed',
    viewer: 'ludus_viewer',
    editor: 'ludus_editor',
    dashboard: 'ludus_dashboard',
    speaker: 'ludus_speaker',
  },
  adobeTypes: {
    '3D': 'application/vnd.adobe.element.3D+dcx',
    animation: 'application/vnd.adobe.element.animation+dcx',
    audio: 'application/vnd.adobe.element.audio+dcx',
    brush: 'application/vnd.adobe.element.brush+dcx',
    characterstyle: 'application/vnd.adobe.element.characterstyle+dcx',
    color: 'application/vnd.adobe.element.color+dcx',
    colortheme: 'application/vnd.adobe.element.colortheme+dcx',
    font: 'application/vnd.adobe.element.font+dcx',
    gradient: 'application/vnd.adobe.element.gradient+dcx',
    graphic: 'application/vnd.adobe.element.graphic+dcx',
    image: 'application/vnd.adobe.element.image+dcx',
    layerstyle: 'application/vnd.adobe.element.layerstyle+dcx',
    look: 'application/vnd.adobe.element.look+dcx',
    material: 'application/vnd.adobe.element.material+dcx',
    paragraphstyle: 'application/vnd.adobe.element.paragraphstyle+dcx',
    pattern: 'application/vnd.adobe.element.pattern+dcx',
    template: 'application/vnd.adobe.element.template+dcx',
    text: 'application/vnd.adobe.element.text+dcx',
    video: 'application/vnd.adobe.element.video+dcx',
  },
  adobeLabels: {
    'application/vnd.adobe.element.3D+dcx': '3D',
    'application/vnd.adobe.element.animation+dcx': 'Animations',
    'application/vnd.adobe.element.audio+dcx': 'Audio',
    'application/vnd.adobe.element.brush+dcx': 'Brushes',
    'application/vnd.adobe.element.characterstyle+dcx': 'Character styles',
    'application/vnd.adobe.element.color+dcx': 'Colors',
    'application/vnd.adobe.element.colortheme+dcx': 'Color themes',
    'application/vnd.adobe.element.font+dcx': 'Fonts',
    'application/vnd.adobe.element.gradient+dcx': 'Gradients',
    'application/vnd.adobe.element.graphic+dcx': 'Graphics',
    'application/vnd.adobe.element.image+dcx': 'Images',
    'application/vnd.adobe.element.layerstyle+dcx': 'Layer styles',
    'application/vnd.adobe.element.look+dcx': 'Looks',
    'application/vnd.adobe.element.material+dcx': 'Materials',
    'application/vnd.adobe.element.paragraphstyle+dcx': 'Paragraph styles',
    'application/vnd.adobe.element.pattern+dcx': 'Patterns',
    'application/vnd.adobe.element.template+dcx': 'Templates',
    'application/vnd.adobe.element.text+dcx': 'Text',
    'application/vnd.adobe.element.video+dcx': 'Videos',
  },
};

export default variables;
